import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nth'
})
export class NthPipe implements PipeTransform {

  transform(data: string, sep: string, nth: number): unknown {
    return data.split(sep)[nth];
  }

}
